module.exports = __webpack_public_path__ + "img/coin.4aebc864.svg";